import { SafetyPlanTestID } from "@/constants/TestID";
import SafetyPlanSection, {
  BulletPointText,
  LinkText,
} from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import { HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface SupportPeopleSectionProps {
  onLinkPress: (text: string) => void;
  supportPeople?: SafetyPlanSupportPerson[];
}

const SupportPeopleSection = ({
  onLinkPress,
  supportPeople: supportPeopleData,
}: SupportPeopleSectionProps) => {
  const supportPeople = supportPeopleData
    ?.filter((support) => support.Name || support.Phone)
    // eslint-disable-next-line max-params
    .map((support, index) => {
      return (
        <HStack key={SafetyPlanTestID.SupportPeople}>
          <BulletPointText
            testID={joinTestIDs(
              SafetyPlanTestID.SupportPeople,
              `name-${index}`,
            )}
            text={`${support.Name}${support.Phone ? " - " : ""}`}
          />

          <LinkText
            linkType="tel"
            onPress={() => {
              onLinkPress(support.Phone || "");
            }}
            testID={joinTestIDs(
              SafetyPlanTestID.SupportPeople,
              `phone-${index}`,
            )}
            text={support.Phone || ""}
          />
        </HStack>
      );
    });

  return (
    <SafetyPlanSection
      shouldPrefixWithBullet
      statements={supportPeople}
      testID={SafetyPlanTestID.SupportPeople}
      title="Names of at least three support people"
    />
  );
};

export default SupportPeopleSection;
